// extracted by mini-css-extract-plugin
module.exports = {"root":"SortByWrapper_root__1sTzl","body":"SortByWrapper_body__2gHEl"};